import { translateObjectData } from '../../utils/locale';
import { atob, applyVAT } from '../../utils/string';

const checkoutAnalytics = (items, setup, totals) => {
	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
	window.dataLayer.push({
		event: 'InitiateCheckout',
		values: {
			currency: setup.currency,
			content_type: 'product',
			contents: items.map((item) => {
				const id = atob(item.id);
				return {
					id: id.slice(id.lastIndexOf('/') + 1),
					quantity: item.quantity,
					item_price: applyVAT(setup, item.price, false, 5),
				};
			}),
			num_items: totals.totalQuantity,
			value: applyVAT(setup, totals.total),
		},
	});

	window.dataLayer.push({
		event: 'InitiateCheckoutGA',
		ecommerce: {
			checkout: {
				products: items.map((item) => {
					const localizedItem = translateObjectData(setup, item);
					return {
						name: localizedItem.name,
						id: item.sku,
						sku: item.sku,
						price: applyVAT(setup, localizedItem.price, false, 5),
						brand: localizedItem.brand,
						category: localizedItem.category,
						variant: localizedItem.variant,
						quantity: item.quantity,
					};
				}),
			},
		},
	});

	window.dataLayer.push({
		event: 'begin_checkout',
		ecommerce: {
			currency: setup.currency,
			value: applyVAT(setup, totals.total),
			items: items.map((item) => {
				const id = atob(item.id);
				const localizedItem = translateObjectData(setup, item);
				const itemCategory = localizedItem.canonicalUri && localizedItem.canonicalUri.split('/').slice(0, -1).reduce((acc, category, j) => ({ ...acc, [`item_category${j > 0 ? j + 1 : ''}`]: category }), {});
				return {
					item_name: localizedItem.name,
					item_id: id.slice(id.lastIndexOf('/') + 1),
					price: applyVAT(setup, localizedItem.price, false, 5),
					item_brand: localizedItem.brand,
					...(itemCategory || {}),
					item_variant: localizedItem.variant,
					quantity: `${item.quantity}`,
				};
			}),
		},
	});
};

export default checkoutAnalytics;
